import React from "react";
import AxiosConfig from "axiosConfig";
import PrivateUserProfile from "./PrivateUserProfile";
import PublicUserProfile from "./PublicUserProfile";
import FriendUserProfile from "./FriendUserProfile";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";
import * as CONSTANT from "constants/text";

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileVisibility: "",
      friendName: "",
      friendAge: CONSTANT.NOT_SHARED,
      friendLocation: CONSTANT.NOT_SHARED,
      friendProfilePic: "",
      cover_pic: "",
      MyDefaultCoverPhoto,
      about_me: "",
      heroes: "",
      cause: "",
      favorite_thing: "",
      dream: "",
      super_powers: "",
      project_interest: [],
      profile_pic: "",
      allFriends: [],
      allGroups: [],
      full_name:'',
    };
  }

  componentDidMount() {
    //if the URL type param is guardian review call a specific endpoint, because this frontend url has different
    // props. The prop that is different in this instance is child_username. This
    // is how the endpoint can determine what view privileges this user has.
    if (this.props.match.params.type === CONSTANT.GUARDIAN_REVIEW) {
      this.fetchGuardianReviewProfileDetails(this);
    } else {
      this.fetchProfileDetails(this);
    }

    AxiosConfig.get("/profile/details/profile-picture/").then((res) => {
      this.setState({
        profile_pic: res.data.profile_pic,
      });
    });
  }

  fetchGuardianReviewProfileDetails(obj) {
    AxiosConfig.get(
      "/profile/" +
        this.props.match.params.child_username +
        "/" +
        this.props.match.params.username +
        "/guardian_review_friend_details/"
    ).then(function (response) {
      obj.setFriendInfo(response);
    });
  }

  fetchProfileDetails(obj) {
    AxiosConfig.get(
      "profile/" + this.props.match.params.username + "/profile_details/"
    ).then(function (response) {
      obj.setFriendInfo(response);
    });
  }

  setFriendInfo(response) {
    if (response.data["visibility"]) {
      if (response.data["visibility"] === "PRIVATE") {
        let about_me = response.data["about_me"];
        let favorite_thing = response.data["favorite_thing"];
        let dream = response.data["dream"];
        let super_powers = response.data["super_powers"];
        let project_interest = response.data["project_interest"];
        let heroes = response.data["heroes"];
        let cause = response.data["cause"];

        let age = response.data["age"];
        let userName = response.data["username"];
           let full_name = response.data["full_name"];
        let location = response.data["location"];
        let profilePic = response.data["profile_pic"];
        let coverPic = response.data["cover_pic"];

        if (about_me === "") {
          about_me = CONSTANT.NOT_SHARED;
        }

        if (favorite_thing === "") {
          favorite_thing = CONSTANT.NOT_SHARED;
        }
        if (dream === "") {
          dream = CONSTANT.NOT_SHARED;
        }

        if (super_powers === "") {
          super_powers = CONSTANT.NOT_SHARED;
        }

        if (project_interest.length === 0) {
          project_interest.push(CONSTANT.NOT_SHARED);
        }

        if (heroes === "") {
          heroes = CONSTANT.NOT_SHARED;
        }

        if (cause === "") {
          cause = CONSTANT.NOT_SHARED;
        }

        if (age === "") {
          age = CONSTANT.NOT_SHARED;
        }
        this.setState((prevState) => ({
          profileVisibility: response.data["visibility"],
          friendStatus: response.data["friend_status"],
          about_me: about_me,
          favorite_thing: favorite_thing,
          dream: dream,
          cause: cause,
          heroes: heroes,
          super_powers: super_powers,
          project_interest: project_interest,
          friendName: userName,
          full_name:full_name,
          friendAge: age,
          friendLocation: location,
          friendProfilePic: profilePic,
          friendCoverPic: coverPic,
        }));
      } else if (response.data["visibility"] === "PUBLIC") {
        let age = response.data["age"];
        let userName = response.data["username"];
           let full_name = response.data["full_name"];
        let location = response.data["location"];
        let profilePic = response.data["profile_pic"];
        let coverPic = response.data["cover_pic"];
        if (age === "") {
          age = CONSTANT.NOT_SHARED;
        }

        this.setState((prevState) => ({
          profileVisibility: response.data["visibility"],
          friendStatus: response.data["friend_status"],
          friendName: userName,
          full_name:full_name,
          friendAge: age,
          friendLocation: location,
          friendProfilePic: profilePic,
          friendCoverPic: coverPic,
        }));
      } else if (response.data["visibility"] === "FRIEND") {
        let about_me = response.data["about_me"];
        let favorite_thing = response.data["favorite_thing"];
        let dream = response.data["dream"];
        let super_powers = response.data["super_powers"];
        let project_interest = response.data["project_interest"];
        let heroes = response.data["heroes"];
        let cause = response.data["cause"];

        let age = response.data["age"];
        let userName = response.data["username"];
           let full_name = response.data["full_name"];
        let location = response.data["location"];
        let profilePic = response.data["profile_pic"];
        let coverPic = response.data["cover_pic"];
        let allFriends = response.data["all_friends"];
        let allGroups = response.data["all_groups"];
        if (about_me === "") {
          about_me = CONSTANT.NOT_SHARED;
        }

        if (favorite_thing === "") {
          favorite_thing = CONSTANT.NOT_SHARED;
        }
        if (dream === "") {
          dream = CONSTANT.NOT_SHARED;
        }

        if (super_powers === "") {
          super_powers = CONSTANT.NOT_SHARED;
        }

        if (project_interest.length === 0) {
          project_interest.push(CONSTANT.NOT_SHARED);
        }

        if (heroes === "") {
          heroes = CONSTANT.NOT_SHARED;
        }

        if (cause === "") {
          cause = CONSTANT.NOT_SHARED;
        }

        if (age === "") {
          age = CONSTANT.NOT_SHARED;
        }
        if (allFriends == null || allFriends == "") {
          allFriends = null;
        }
        if (allGroups == null || allGroups == "") {
          allGroups = null;
        }
        this.setState((prevState) => ({
          profileVisibility: response.data["visibility"],
          friendStatus: response.data["friend_status"],
          about_me: about_me,
          favorite_thing: favorite_thing,
          dream: dream,
          cause: cause,
          heroes: heroes,
          super_powers: super_powers,
          project_interest: project_interest,
          friendName: userName,
          full_name:full_name,
          friendAge: age,
          friendLocation: location,
          friendProfilePic: profilePic,
          friendCoverPic: coverPic,
          allFriends: allFriends,
          allGroups: allGroups
        }));
      }
    }
  }

  render() {
    
    if (this.state.profileVisibility === "PRIVATE") {
      return (
        <PrivateUserProfile
          friendSlug={this.props.match.params.username}
          friendStatus={this.state.friendStatus}
          requestId={this.props.match.params.request_id}
          requestType={this.props.match.params.type}
          about_me={this.state.about_me}
          favorite_thing={this.state.favorite_thing}
          dream={this.state.dream}
          cause={this.state.cause}
          heroes={this.state.heroes}
          super_powers={this.state.super_powers}
          project_interest={this.state.project_interest}
          friendName={this.state.friendName}
          full_name={this.state.full_name}
          friendAge={this.state.friendAge}
          friendLocation={this.state.friendLocation}
          friendProfilePic={this.state.friendProfilePic}
          friendCoverPic={this.state.friendCoverPic}
          profilePic={this.state.profile_pic}
          history={this.props.history}
          groupName={this.props.match.params.group_name}
          groupRequestId={this.props.match.params.group_request_id}
          groupID={this.props.match.params.group_id}
          
        />
      );
    } else if (this.state.profileVisibility === "PUBLIC") {
      return (
        <PublicUserProfile
          friendSlug={this.props.match.params.username}
          requestId={this.props.match.params.request_id}
          type={this.props.match.params.type}
          friendName={this.state.friendName}
          full_name={this.state.full_name}
          friendAge={this.state.friendAge}
          friendLocation={this.state.friendLocation}
          friendProfilePic={this.state.friendProfilePic}
          friendCoverPic={this.state.friendCoverPic}
          friendStatus={this.state.friendStatus}
          profilePic={this.state.profile_pic}
          history={this.props.history}
          groupName={this.props.match.params.group_name}
          groupRequestId={this.props.match.params.group_request_id}
          groupID={this.props.match.params.group_id}
        />
      );
    } else if (this.state.profileVisibility === "FRIEND") {
      return (
        <FriendUserProfile
          friendSlug={this.props.match.params.username}
          requestId={this.props.match.params.request_id}
          requestType={this.props.match.params.type}
          about_me={this.state.about_me}
          favorite_thing={this.state.favorite_thing}
          dream={this.state.dream}
          cause={this.state.cause}
          heroes={this.state.heroes}
          super_powers={this.state.super_powers}
          project_interest={this.state.project_interest}
          friendName={this.state.friendName}
          full_name={this.state.full_name}
          friendAge={this.state.friendAge}
          friendLocation={this.state.friendLocation}
          friendProfilePic={this.state.friendProfilePic}
          friendCoverPic={this.state.friendCoverPic}
          profilePic={this.state.profile_pic}
          history={this.props.history}
          type={this.props.match.params.type}
          groupName={this.props.match.params.group_name}
          groupRequestId={this.props.match.params.group_request_id}
          groupID={this.props.match.params.group_id}
          allFriends={this.state.allFriends}
          allGroups={this.state.allGroups}
        />
      );
    } else {
      return null;
    }
  }
}

export default UserProfile;
